<template>
    <div>
        <VerifiedLable
            :title="title"
            :tagnewid="tagnewid"
            :required="required"
            :disableMLtitle="disableMLtitle"
            :tooltipLabel="tooltipLabel"
            :tooltipPosition="tooltipPosition"
            :tooltipType="tooltipType"
            :tooltipSize="tooltipSize"
            :tooltipMultilined="tooltipMultilined"
        />
        <div tabindex="0" 
            ref="cpbox" 
            class="color-picker" 
            :class="{'disabled-select': disabled}" 
            @click="openPicker()"
        >
            <div class="cor-hexa" type="text" v-text="color" :disabled="!editable||disabled"/>
            <input type="text" class="cor-hexa-input" :disabled="disabled"/>
            <div class="color-block" :style="{ 'background-color': color }"></div>
            <div class="picker" v-if="pickerWindow&&!disabled" @click.stop>
                <label> {{ $t('cores') }} </label>
                <div class="all-colors">
                    <div 
                    v-for="(color, i) in colors" 
                    :key="i" class="color-block" 
                    :style="{ 'background-color': color}" 
                    :class="{ 'selected': isSelected(color, false ) }" 
                    @click="pickElement(color)"
                    ></div>
                </div>
                <button class="delete-btn" type="button" @click="openPicker()">
                    {{ $t('cancelar') }}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import VerifiedLable from "@/components/shared/VerifiedLable.vue";

export default {
    components: {
        VerifiedLable
    },
    props: {
        editable: {
            default: false,
        },
        color: {
            default: '#D0CFCF',
        },
        disabled: {
            default: false,
            type: Boolean
        },
        title: {
            default: "",
            type: String
        },
        // Id do tagnew referente ao .env na raiz do sistema
        tagnewid: undefined,
        // O título fica com a cor primária da empresa e com um asterisco após o título
        required:{ 
            type: Boolean,
            default: false
        },
        /* Caso tenha uma informação adicional sobre o campo */
        tooltipLabel: {
            type: String,
            default: null
        },
        tooltipPosition: {
            type: String,
            default: 'is-right'
        },
        tooltipType: {
            type: String,
            default: 'is-dark'
        },
        tooltipMultilined: { 
            type: Boolean,
            default: true
        },
        tooltipSize: {
            type: String,
            default: 'is-large'
        },
        disableMLtitle: {
            type: Boolean,
            default: false
        },
    },
    data() {
        return {
            colors:[
                '#F44336',
                '#E91E63',
                '#9C27B0',
                '#673AB7',
                '#3F51B5',
                '#2196F3',
                '#03A9F4',
                '#00BCD4',
                '#009688',
                '#4CAF50',
                '#8BC34A',
                '#CDDC39',
                '#FFEB3B',
                '#FFC107',
                '#FF9800',
                '#FF5722',
                '#795548',
                '#9E9E9E',
                '#607D8B',
                '#000000'
            ],
            pickerWindow: false,
        };
    },
    mounted() {
        let select = this.$refs['cpbox'];
        select.addEventListener('focusout', event => {
            this.pickerWindow = false;
        });
    },
    methods: {
        openPicker(){
            this.pickerWindow = !this.pickerWindow;
        },
        isSelected(compareColor, isReduced){
            let tempcolor = this.color.toLowerCase();
            compareColor = compareColor.toLowerCase();            

            if (isReduced == false){
                return tempcolor == compareColor? true:false;
            } else {
                return (tempcolor == compareColor || tempcolor == "#fff" || tempcolor == "000")? true:false
            }
        },
        pickElement(color){
            this.pickerWindow = false;
            this.$refs.cpbox.classList.remove('mandatory');
            this.$emit('colorpicked', color);
        }
    }

}

</script>

<style lang="scss">
.color-picker {
    width: 100%;
    font-size: 15px;
    padding: 6px;
    align-items: center;
    justify-content: space-between;
    display: flex;
    border: 1px solid #D0CFCF;
    background: $sovis-white;
    box-sizing: border-box;
    border-radius: 3px;
    cursor: pointer;
    position: relative;
    z-index: 8;
    
    .cor-hexa{
        display: flex;
        align-items: center;
        color: $darker-gray-color;
    }

    .cor-hexa-input{
        display: none;
    }

    > .color-block {
        display: inline-block;
        cursor: pointer;
        width: 30px;
        height: 30px;
        border-radius: 4px;
        position: absolute;
        right: 2px;

        &.selected{
            border: 2px solid $primary-color-hover;
        }
    }

    > .picker{
        position: absolute;
        top: 25px;
        right: 2px;
        width: 190px;
        padding: 5px;
        background: $sovis-white;
        box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
        cursor: default;

        >label{
            font-style: normal;
            font-weight: 600;
            line-height: normal;
            font-size: 14px;
            color: #333333;
        }

        > .all-colors{
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            padding: 5px 0;
            

            .color-block{
                margin-right: 5px;
                margin-bottom: 5px;
                width: 30px;
                height: 30px;
                border-radius: 8px;
                overflow: hidden;
                cursor: pointer;

                > .red-line{
                    border-left: 3px solid #F44336;
                    height: 130%;
                    transform: rotate(45deg);                    
                    margin-top: 3px;
                    margin-left: 10px;
                }
            }
        }

        .delete-btn {            
            font-size: 12px;
            text-align: center;
            padding: 10px 20px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            color: $darker-gray-color;
            float: right;
            @include exclude-button();
        }
    }
    &.mandatory{
        border: 1px solid $red-alert !important;
        border-radius: 6px;
    }
}
.disabled-select {
    background-color: rgba(208, 207, 207, 0.6);
    cursor: default;
}
</style>

